import { SelectionModel } from '@angular/cdk/collections';
import { FlatTreeControl } from '@angular/cdk/tree';
import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { MatTreeFlattener, MatTreeFlatDataSource } from '@angular/material/tree';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ManageOrdersService } from 'projects/fe-common-v2/src/lib/services/manage-order.service';
import { take } from 'rxjs/operators';
import { ApproveRejectOrderComponent } from '../../../popups/approve-reject-order/approve-reject-order.component';
import { HelperService } from '../../../service/helper.service';
import { orderStatusApproveRejet } from '../order-management-model';
import swal from 'sweetalert2';
import { CustomerManageOrdersService } from '../../../service/cutomer-manage-order.service';
import { CustomTimeDurationPipe } from '../../../pipes/custom-time-duration.pipe';


interface OrderItemNode {
  etcNew: any;
  quantity: number;
  selectEnabled: boolean;
  selectSupplier: boolean;
  expandable: boolean;
  priceType: string;
  etcData: any;
  hasChild: number;
  id: string;
  customizeVisible: boolean;
  sellingCatalogTypeId: any;
  sellingCatalogType: any;
  customerPrice: number;
  expectedTimeToDeliver: any;
  level: any;
  macroTaskName: any;
  taskName: any;
  unitName: any;
  name: string;
  qty?: number;
  internalSupplier?: any;
  sellingPrice?: number;
  etc?: string;
  totalSellingPrice?: number;
  children?: OrderItemNode[];
  editable?: boolean;
  fixedVariablePrice?: number;
  sellingCatalogId?: string;
  sellingCatalogName?: string;
  supplier?: string;
  customize: boolean;
  _id: string;
  uniqueId: number;
  isOptional:boolean;
  doNotInvoice:boolean;
  showInProposal:boolean;
  isAccessoryItem:boolean;


}

interface FlatNode {
  expandable: boolean;
  name: string;
  level: number;
  qty?: number;
  internalSupplier?: any;
  sellingPrice?: number;
  etc?: string;
  totalSellingPrice?: number;
  editable?: boolean;
  fixedVariablePrice?: number
  sellingCatalogId?: string;
  sellingCatalogName?: string;
  supplier?: string;
  etcData?: any;
  customize: boolean;
  sellingCatalogTypeId: string;
  sellingCatalogType: string;
  id: string;
  uniqueId: number;
  customizeVisible: boolean;
  isOptional:boolean;
  isAccessoryItem:boolean;
  doNotInvoice:boolean;
  showInProposal:boolean,

}
@Component({
  selector: 'app-order-planning',
  templateUrl: './order-planning.component.html',
  styleUrls: ['./order-planning.component.scss']
})

export class OrderPlanningComponent implements OnInit {
  langSubscription: any = null;
  currentLanguage: string ;
  totalSellingPrice: any = 0;
  realisation: number = 0;
  discountedPrice: number = 0;
  etc: string = "";
  selectedCatalog;
  catalogs = [];
  isStep1Valid = false;
  isStep2Valid = false;
  isStep3Valid = false;
  selection = new SelectionModel<any>(true, []);
  title = 'ORDERMANAGEMENT.ViewLabel';
  displayedColumns: string[] = ['name', 'priceType', 'qty', 'sellingPrice', 'etc', 'totalSellingPrice','accessoryItem','IsOptional'];

  @ViewChild('stepper') stepper!: MatStepper;

  treeControl = new FlatTreeControl<FlatNode>(
    node => node.level,
    node => node.expandable
  );
  @Input() orderId = "";
  disabledMode = true;
  originalCustomize = false;
  treeFlattener = new MatTreeFlattener(
    (node: OrderItemNode, level: number) => {
      if (this.originalCustomize) {
        return node;
      }
      node.expandable = !!node.children && node.children.length > 0;
      node.name = node.macroTaskName || node.taskName || node.unitName;
      node.level = level;
      node.qty = node.qty || 1;
      node.sellingPrice = node.sellingPrice || node.customerPrice || 0;
      node.etc = node.expectedTimeToDeliver.time + ' ' + this.toTitleCase(node.expectedTimeToDeliver.type);
      node.totalSellingPrice = node.totalSellingPrice || node.customerPrice || 0;
      node.editable = !node.level;
      node.sellingCatalogTypeId = node.sellingCatalogTypeId;
      node.sellingCatalogType = node.sellingCatalogType;
      node.priceType = node.fixedVariablePrice === 1 ? 'Fixed' : 'Variable';
      node.etcData = node.expectedTimeToDeliver;
      node.hasChild = node.children?.length;
      node.id = node._id;
      node.uniqueId = node.uniqueId;
      node.isOptional = node.isOptional || false
      node.isAccessoryItem = node.isAccessoryItem || false
      node.customizeVisible = node.hasChild && node.level === 0 ? true : false;
      node.selectEnabled = node.level === 0 ? true : false;
      node.sellingPrice = (node.doNotInvoice === true && node.doNotInvoice == true) ?  0 :  node.sellingPrice;
      node.totalSellingPrice =  (node.doNotInvoice === true && node.doNotInvoice == true) ?  0 :  node.totalSellingPrice;
      return node;
    },
    node => node.level,
    node => node.expandable,
    node => node.children
  );
  orderDetails = null;
  dataSource: any = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  selectedItems = []
  orderItems: OrderItemNode[] = [];
  search = "";
  // Without Search
  originalNodes = [];
  orderStatusApproveRejet = orderStatusApproveRejet;
  sidebarMenuName: string;
  constructor(
    private cdRef: ChangeDetectorRef,
    public customTimeDuration : CustomTimeDurationPipe,
    public dialog: MatDialog,
    private orderService: CustomerManageOrdersService,
    private router: Router,
    private helper: HelperService,
    public translate: TranslateService,
    private route: ActivatedRoute,


  ) {
    this.langSubscription = this.translate.onLangChange.subscribe(event => {
      this.currentLanguage = event.lang;
       this.updateEtc();
    });
    this.dataSource.data = this.orderItems;
  }

  hasChild = (_: number, node: FlatNode) => node.expandable;

  ngOnInit() {
    this.currentLanguage = this.translate.currentLang || 'it';
    this.sideMenuName();
    const id = this.route.snapshot.paramMap.get('id');
    this.orderId = id;
    this.getDetails(id);

  }

  sideMenuName() {
    this.sidebarMenuName = this.translate.instant('ORDERMANAGEMENT.MANAGEORDERS.title'),
      this.helper.sideMenuListName.next(this.sidebarMenuName);
  }

  addRemoveItem(data, value) {
    this.selection.toggle(data);

    if (value.checked) {
      data.disable = false;
      const index = this.dataSource.data.findIndex(node => node.uniqueId === data.uniqueId);
      if (index > -1) {
        this.dataSource.data.splice(index, 1);
      }
      this.dataSource.data.unshift(data);
      this.originalCustomize = true;
      this.dataSource.data = [...this.dataSource.data]
      setTimeout(() => {
        this.originalCustomize = false;
      }, 1000);

    } else {
      this.treeControl.collapse(data)
      data.disable = true;
    }
    this.calculateTotals()
  }

  resetSearch(): void {
    this.search = '';
    this.dataSource.data = this.originalNodes;
  }
  findTopParentByName(nodes: any[], searchText: string): any[] {
    const result = new Set<any>();

    // Iterate through the top-level nodes
    for (const parent of nodes) {
      if (parent.name.toUpperCase().includes(searchText.toUpperCase())) {
        result.add(parent);
      }
      // Check children of each parent
      for (const child of parent.children || []) {
        if (child.name.toUpperCase().includes(searchText.toUpperCase())) {
          result.add(parent);
          const flatNode = this.treeControl.dataNodes.find(node => node.uniqueId === parent.uniqueId);
          if (flatNode) {
            this.treeControl.expand(flatNode)
          }
        }
        // Check grandchildren of each child
        for (const grandchild of child.children || []) {
          if (grandchild.name.toUpperCase().includes(searchText.toUpperCase())) {
            result.add(parent);
            const flatNode = this.treeControl.dataNodes.find(node => node.uniqueId === parent.uniqueId);
            if (flatNode) {
              this.treeControl.expand(flatNode)
            }
          }
        }
      }
    }

    return Array.from(result);
  }



  onKeyUp(searchTextValue: any): void {
    this.originalCustomize = true;
    if (this.search) {
      this.dataSource.data = this.findTopParentByName(this.originalNodes, this.search)
    } else {
      this.dataSource.data = this.originalNodes;
    }
    setTimeout(() => {
      this.originalCustomize = false;
    }, 1000);
  }

  // Method to reverse the changes from payload to tree nodes
  // reversePayloadToTree(payload: any): OrderItemNode[] {
  //   return payload?.items?.map(item => this.traverseItem(item));
  // }

  reversePayloadToTree(payload: any): OrderItemNode[] {
    return (payload?.items || [])
      .filter(item => !item.doNotInvoice || item.showInProposal)
      .map(item => this.traverseItem(item));
  }

  // Helper method to traverse each item recursively
  traverseItem(item: any) {
    const node = {
      _id: item.typeId,
      itemId:item._id,
      sellingCatalogTypeId: item.typeId,
      macroTaskName: item.name,
      taskName: item.name,
      unitName: item.name,
      customerPrice: item.sellingPrice,
      expectedTimeToDeliver: item.expectedTimeToComplete,
      sellingPrice: item.sellingPrice,
      totalSellingPrice: item.totalSellingPrice,
      fixedVariablePrice: item.fixedVariablePrice,
      isOptional:item.isOptional || false ,
      isAccessoryItem:item.isAccessoryItem || false ,
      qty: item.quantity || 1,
      sellingCatalogType: item.type || '',
      children: (item.children || []).filter(child => !child.doNotInvoice || child.showInProposal).map(child => this.traverseItem(child)),
    };
    return node;
  }
  // Helper function to reverse etc data
  reverseEtc(etc: Number) {
    if (!etc) {
      etc = 0;
    }
    return {
      time: etc,
      type: "HOUR"
    }
  }






  getDetails(id) {
    this.orderService.getOrderDetails(id).subscribe((res: any) => {
      if (res.result && res.data) {
        let orderDetailsTemp = res.data?.items.filter(x=>(!x.doNotInvoice || x.showInProposal));
        this.orderDetails = res.data;
        if (this.orderDetails?.sellingCatalogId) {
          this.selectedCatalog = this.orderDetails.sellingCatalogId;
        }
        this.getAllSellingCatalog(this.orderDetails.customerId);

        // this.onCatalogChange(this.selectedCatalog);
        if (this.orderDetails?.items?.length) {
          this.totalSellingPrice = this.orderDetails.totalSellingPrice;
          this.discountedPrice = this.orderDetails.discountedSellingPrice;
          this.realisation = this.orderDetails.realisation;
          const days = (this.orderDetails.expectedTimeToComplete/8).toFixed(2);
          // this.etc =  `${days} Days / ${this.orderDetails.expectedTimeToComplete} Hours`;
           this.etc =this.customTimeDuration.transform(Number(this.orderDetails.expectedTimeToComplete),'HOUR')
          this.helper.toggleLoaderVisibility(true);
          this.dataSource.data = this.reversePayloadToTree(this.orderDetails);
          console.log("data",this.dataSource.data)
          this.traverseAndCalculateEstimatedTime(this.dataSource.data)
          this.traverseAndAddIds(this.dataSource.data)
          this.cdRef.detectChanges();
          setTimeout(() => {
            this.traverseAndCustomise(this.dataSource.data)
            this.selection.select(...this.dataSource._flattenedData.value);
            this.originalNodes = [...this.dataSource.data];

          }, 100);

        }
        this.helper.toggleLoaderVisibility(false);
      } else {
        this.helper.toggleLoaderVisibility(false);
        swal.fire(
          '',
          this.translate.instant(res.reason),
          'info'
        );
      }
    });
  }

  getAllSellingCatalog(id) {
    this.helper.toggleLoaderVisibility(true);
    this.orderService.getSellingList({ customerId: id }).pipe(take(1)).subscribe((res: any) => {
      if (res.result) {
        this.catalogs = res.data || [];
        this.helper.toggleLoaderVisibility(false);
      } else {
        this.catalogs = [];
      }
    }, (err: any) => {
      this.helper.toggleLoaderVisibility(false);
      swal.fire(
        '',
        this.translate.instant(err?.error?.message),
        'info'
      );
    });
  }




  transformCatalogData = (catalog) => {
    if (catalog.data && catalog.data.catalogList) {
      catalog.data.catalogList.forEach(item => {
        if (item.sellingCatalogDetails) {
          Object.assign(item, item.sellingCatalogDetails);
          delete item.sellingCatalogDetails;
        }
      });
    }
    return catalog;
  }

  uniqueIdCounter = 1;
  // Recursive function to traverse and modify children
  traverseAndAddIds = (items) => {
    items.forEach(item => {
      // Add unique ID to the current item
      this.uniqueIdCounter = this.uniqueIdCounter + 1
      item.uniqueId = this.uniqueIdCounter
      // Recursively traverse children if present
      if (item.children && Array.isArray(item.children)) {
        this.traverseAndAddIds(item.children);
      }
    });
  }

  traverseAndCustomise = (items) => {
    items.forEach(item => {

      item.selectEnabled = !item.customize;
      if (item.children && Array.isArray(item.children)) {
        item.customizeVisible = true;
        item.children.forEach(child => {
          child.selectEnabled = item.customize;
          if (child?.children?.length) {
            child.selectEnabled = !child.customize && item.customize;
            child.customizeVisible = item.customize;
            if (child.customize && item.customize) {
              child.children.forEach(grandChild => {
                grandChild.selectEnabled = true;
              })
            }

          }
        });

      }

    });
  }


  traverseAndCalculateSellingPrice = (items) => {
    for (const item of items) {
      if (item?.children?.length) {
        if (item?.customize) {
          item.sellingPrice = this.traverseAndCalculateSellingPrice(item.children);
          item.totalSellingPrice = item.sellingPrice * item.qty;

        }
      }
    }

    return items.reduce((sum, item) => {
      return sum + item.sellingPrice
    }, 0);
  }
  traverseAndCalculateEstimatedTime = (items) => {
    for (const item of items) {
      if (item?.children?.length) {
        if (item.customize) {
          // Recursively calculate the estimated time for child items
          this.traverseAndCalculateEstimatedTime(item.children);

          // Initialize parent etcNewData
          item.etcNewData = { type: "DAYS", time: 0 };

          // Sum the etcData of children
          for (const child of item.children) {
            if (child.etcData) {
              const timeInDays = child.etcData.type === "HOUR" ? child.etcData.time / 8 : child.etcData.time;
              item.etcNewData.time = Number(item.etcNewData.time) + Number(timeInDays);
            }
          }

          // Format etcNew for the parent item
          item.etcNew = item.etcNewData.time + ' ' + this.toTitleCase(item.etcNewData.type);
        }
      }
    }
  }








  toTwoDecimal = (number) => {
    return parseFloat(number.toFixed(2));
  }
  toTitleCase = (str) => {
    if (str === 'HOUR') {
      str = 'HOURS'
    }
    return str.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
  }

  calculateTotals() {
    this.totalSellingPrice = 0;
    this.realisation = 0;
    this.discountedPrice = 0;
    let hours = 0;
    let days = 0;
    this.selection.selected.forEach(node => {
      if (node.editable) {
        if(node.isOptional) {
          this.totalSellingPrice = this.totalSellingPrice + 0;
        }else{
          this.totalSellingPrice = this.totalSellingPrice + node.totalSellingPrice;
        }
        // this.totalSellingPrice = this.totalSellingPrice + node.totalSellingPrice;
        this.discountedPrice = this.totalSellingPrice;
        const validEtcData = node.customize ? node.etcNewData : node.etcData;
        if (validEtcData?.type === "HOUR") {
          hours = hours + (validEtcData.time * node.qty)
        } else if (validEtcData?.type === "DAYS") {
          days = days + (validEtcData.time * node.qty)
        }
      }
    })
    const totalDays = (days + hours / 8).toFixed(2);
    const totalHours = (hours + days * 8).toFixed(2)
    // this.etc = `${totalDays} Days ~ ${totalHours} Hours`
     this.etc =this.customTimeDuration.transform(Number(this.orderDetails.expectedTimeToComplete),'HOUR')
    this.totalSellingPrice = this.toTwoDecimal(this.totalSellingPrice);
    this.realisation = this.toTwoDecimal(this.realisation);
  }
  onChange(node: FlatNode): void {
    this.cdRef.detectChanges()
    setTimeout(() => {
      this.traverseAndCalculateSellingPrice(this.dataSource.data);
      this.traverseAndCalculateEstimatedTime(this.dataSource.data)
      node.totalSellingPrice = node.sellingPrice * node.qty;
      node.etc = (node.etcData.time * node.qty) + ' ' + this.toTitleCase(node.etcData.type);

      this.calculateTotals();


    }, 10);

  }





  changeStatusReject(): any {
    const dialogRef = this.dialog.open(ApproveRejectOrderComponent, {
      data: {
        heading: 'ORDERMANAGEMENT.MANAGEORDERS.RejectOrderTitle',
        id: this.orderId,
        type: 'reject',
        status: orderStatusApproveRejet.REFUSED,
        message: 'ORDERMANAGEMENT.RejectReason',
        message1: 'ORDERMANAGEMENT.InternalComment'
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        swal.fire(
          '',
          this.translate.instant('ORDERMANAGEMENT.MANAGEORDERS.OrderUpdateSuccess'),
          'success'
        );
        this.router.navigate(['/customer-order']);
      }
    });
  }

  changeStatusApprove(): any {
    const dialogRef = this.dialog.open(ApproveRejectOrderComponent, {
      data: {
        heading: 'ORDERMANAGEMENT.MANAGEORDERS.ApproveOrderTitle',
        id: this.orderId,
        type: 'accept',
        status: orderStatusApproveRejet.approved,
        message1: 'ORDERMANAGEMENT.InternalComment'
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        swal.fire(
          '',
          this.translate.instant('ORDERMANAGEMENT.MANAGEORDERS.OrderUpdateSuccess'),
          'success'
        );
        this.router.navigate(['/customer-order']);
      }
    });
  }


  addToProposal(data){
    if(this.orderDetails.status === orderStatusApproveRejet.REFUSED || this.orderDetails.status === orderStatusApproveRejet.approved){
         swal.fire('',this.translate.instant('ORDERMANAGEMENT.MANAGEORDERS.TasksCannotBeUpdated'),'info' );
         return
    }
    const id = this.route.snapshot.paramMap.get('id');
    this.orderService.updateOrderbyTask(id,data).subscribe((res: any) => {
      if (res) {
        this.getDetails(id);
        this.helper.toggleLoaderVisibility(false);
        swal.fire(
          '',
          this.translate.instant('ORDERMANAGEMENT.MANAGEORDERS.ApproveStatusOrder'),
          'success'
        );
      } else {
        this.helper.toggleLoaderVisibility(false);
       ;
      }
    }, (err) => {
      this.helper.toggleLoaderVisibility(false);
      swal.fire(
        '',
        this.translate.instant(err?.error?.message),
        'info'
      );
    });
  }
  private updateEtc() {
    const validEtcData = this.orderDetails?.etcData?.find(d => d.isValid);
    this.etc = this.customTimeDuration.transform(this.orderDetails?.expectedTimeToComplete,'HOUR');
  }

  nextStep() {
    this.isStep1Valid = true;
    this.cdRef.detectChanges();
    this.stepper.next();

  }
  nextStep3() {
    this.isStep2Valid = true;
    this.cdRef.detectChanges();
    this.stepper.next();
  }
}
